module.exports = __webpack_public_path__ + "img/slider1-1.32c378fd.png";